import React from 'react';
import { Box, Typography } from '@mui/material';
import { getText } from '../common/MultiLanguageText';
import { dashboardTokens as t } from './tokens';

export default function DashboardHeader({ language, company }) {
    const companyName = company ? getText(company, 'name', language) : '';

    return (
        <Box sx={{
            display: 'flex',
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            mb: 3,
        }}>
            <Box>
                <Typography component="h1" sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: t.color.fg,
                    lineHeight: 1.2,
                }}>
                  {companyName}
                </Typography>
            </Box>
        </Box>
    );
}
